









import Vue from 'vue';
import { Track } from '@/interfaces/track';

import MusicCard from '@/components/MusicCard.vue';

export default Vue.extend({
  name: 'MusicCardList',
  components: {
    MusicCard,
  },
  props: {
    tracks: {
      required: true,
      type: Array as () => Array<Track>,
    },
  },
});
